/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

export const styles:any[] = ['.help-block[_ngcontent-%COMP%] {margin-bottom:0px;}'];


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/query-selector.component.css.shim.ngstyle.ts